export const WIRE_TOOLTIP = {
  title: 'To send ACH, create a new payee',
  description:
    'To send payment another way, you must create a new payee account. You may keep this account active, or delete it.'
};

export const ACH_TOOLTIP = {
  title: 'To send wires, create a new payee',
  description:
    'To send payment another way, you must create a new payee account. You may keep this account active, or delete it.'
};
